import i18n from '@/i18n';
import router from '@/router';
import {
  NewProjectGetters,
  NewProjectActions,
  NewProjectMutations
} from '@/app/features/projects/new-project/new-project.keys';
import { newProjectService } from '@/app/features/projects/new-project/new-project.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';

export const getInitialState = () => {
  return {
    isCreatingProject: false,
    newProject: {
      name: '',
      status: null,
      start_date: null,
      client_reference_number: '',
      end_client_reference_number: ''
    }
  };
};

export const newProjectStore = {
  state: getInitialState,
  getters: {
    [NewProjectGetters.NewProject]: state => {
      return state.newProject;
    },
    [NewProjectGetters.IsCreatingProject]: state => {
      return state.isCreatingProject;
    }
  },
  mutations: {
    [NewProjectMutations.SetNewProjectSuccess]: state => {
      state.newProject = getInitialState().newProject;
    },
    [NewProjectMutations.SetIsCreatingProject]: (state, isCreating) => {
      state.isCreatingProject = isCreating;
    }
  },
  actions: {
    [NewProjectActions.CreateProject]: ({ commit, dispatch }, projectData) => {
      commit(NewProjectMutations.SetIsCreatingProject, true);

      newProjectService
        .createProject(projectData)
        .then(project => {
          dispatch(TolMessagesActions.SetMessages, {
            text: i18n.t('projects.newProject.success', { name: project.name })
          });
          router.replace({ path: `/projects/${project.reference_number}` }).catch(() => {});
          commit(NewProjectMutations.SetNewProjectSuccess);
        })
        .catch(error => {
          const errorItems = Object.keys(error.data);
          let items = [];
          for (let item of errorItems) {
            if (item !== 'statusCode') {
              items = items.concat(error.data[item]);
            }
          }
          dispatch(TolErrorsActions.SetError, { items });
        });

      commit(NewProjectMutations.SetIsCreatingProject, false);
    },
    [NewProjectActions.SetNewProject]: ({ commit }) => {
      commit(NewProjectMutations.SetNewProjectSuccess);
    }
  }
};
